<template>
    <div class="">
        <div class="content content-block">
        <h4 class="title">
          Driver Information
          <small>
            <a @click.prevent="toggleModal" href="#">(edit)</a>
          </small>
        </h4>
          <dl class="floated-list">
            <dt>drivers license no.</dt>
            <dd>{{ carrierInfo.carrierCommercialDriverLicenseNumber }}</dd>

            <dt>MC/DOT Number</dt>
            <dd>{{ carrierInfo.carrierMotorCarrierNumber }}</dd>

            <dt>Date of Birth</dt>
            <dd>{{ formattedDateOfBirth }}</dd>

            <dt>Truckl Instant Pay</dt>
            <dd>{{ carrierInfo.carrierAlwaysFactorFlag? 'Active' : 'Not Active' }}</dd>
          </dl>
          <div class="is-clearfix"></div>
        </div>

      <!--
      <company-info-modal v-model="currentCompanyInfo" :show.sync="showModal"></company-info-modal>
      -->
      <carrier-modal v-model="carrierInfo"
                     :show-equipment-info="false"
                     :show-insurance-info="false"
                     :show-documents-info="false"
                     :show.sync="showModal"></carrier-modal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { format as formatDate } from 'date-fns'
import CarrierModal from '@/components/CarrierInfo/Modal'

export default {
  name: 'CarrierInfo',

  data() {
    return {
      showModal: false
    }
  },

  mounted() {
    this.getMyDetails()
  },

  computed: {
    ...mapGetters('user', ['accountInfo']),

    carrierInfo() {
      return this.accountInfo.carrier
    },

    formattedDateOfBirth() {
      return formatDate(this.carrierInfo.carrierDateOfBirth, 'MMMM DD, YYYY')
    }
  },

  methods: {
    ...mapActions('user', ['getMyDetails']),

    toggleModal() {
      this.showModal = !this.showModal
    }
  },

  components: {
    CarrierModal
  }
}
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 15px;

  small {
    font-weight: lighter;
    font-size: 0.7em;
  }
}

dl {
  margin-left: 15px;
}
dt {
  text-transform: capitalize;
}

dt,
dd {
  margin-top: 12px;
}
</style>
